import { Translation } from './translation';

export const de: Translation = {
  common: {
    apply: 'Übernehmen',
    type: 'Typ',
    showLess: 'Weniger anzeigen',
    showMore: 'Mehr anzeigen',
    map: 'Karte',
    list: 'Liste',
    results: '{count} Ergebnisse',
    continue: 'Weiter',
    back: 'Zurück',
    currency: {
      short: 'CHF',
      price: `CHF {price}.–`,
      pricePerMonth: `CHF {price}.– / Monat`,
      pricePerSquareMeter: `CHF {price}.–/m<sup>2</sup>`,
    },
    details: "Details",
  },
  mapPrivacy: {
    text: `
      Um die Karte des Drittanbieters Google Maps anzeigen zu können,
      brauchen wir Ihre Einwilligung zur Verwendung von Cookies.
    `,
    button: `Cookies verwalten`,
  },
  filters: {
    common: {
      reset: 'zurücksetzen',
      resetAll: 'alles zurücksetzen',
      deleteAll: 'alle löschen',
      filter: 'Filter',
      additionalFilters: 'Weitere Filter',
      showResults: 'Ergebnisse anzeigen',
      showXResults: '{count} Ergebnisse anzeigen',
      modifySearch: 'Suche anpassen',
      in: 'in',
      title_rent: {
        none: 'Immobilien mieten',
        house: 'Haus mieten',
        flat: 'Wohnung mieten',
        commercial: 'Gewerbeobjekt mieten',
      },
      title_buy: {
        none: 'Immobilien kaufen',
        house: 'Haus kaufen',
        flat: 'Wohnung kaufen',
        land: 'Grundstück kaufen',
        income: 'Renditeobjekt kaufen',
        commercial: 'Gewerbeobjekt kaufen',
      },
    },
    search: {
      label: 'Kanton, Ort, PLZ, Objekt ID, ...',
      noResults: 'Keine Resultate, bitte überprüfen Sie die Schreibweise.',
    },
    contractType: {
      buy: 'Kaufen',
      rent: 'Mieten',
    },
    category: {
      main: {
        label: 'Kategorie',
        all: 'Alle',
        house: 'Haus',
        apartment: 'Wohnung',
        estate: 'Grundstück',
        incomeProperty: 'Renditeobjekt',
        commercial: 'Gewerbe',
      },
      sub: {
        businessHouse: 'Gewerbehaus',
        garageParking: 'Parkplatz/Garage',
        commercialResidentialBuilding: 'Wohn- und Geschäftshaus',
        office: 'Büro',
        shop: 'Ladenfläche',
        warehouse: 'Lager',
        factory: 'Fabrik',
        hotel: 'Hotel',
        restaurant: 'Restaurant',
        practice: 'Praxis',
        multiFamilyHouse: 'Mehrfamilienhaus',
        buildingLand: 'Bauland',
        agriculturalLand: 'Agrarland',
        industrialLand: 'Gewerbeland',
        atticFlat: 'Attikawohnung',
        roofFlat: 'Dachwohnung',
        maisonette: 'Maisonette',
        studio: 'Studio',
        terraceFlat: 'Terrassenwohnung',
        loft: 'Loft',
        gardenFlat: 'Gartenwohnung',
        floorFlat: 'Etagenwohnung',
        holidayFlat: 'Ferienwohnung',
        furnishedFlat: 'Möblierte Wohnung',
        oneFamilyHouse: 'Einfamilienhaus',
        midTerraceHouse: 'Reihenmittelhaus',
        endTerraceHouse: 'Reiheneckhaus',
        rustico: 'Rustico',
        semidetachedHouse: 'Doppeleinfamilienhaus',
        terraceHouse: 'Terrassenhaus',
        farmhouse: 'Bauernhaus',
        mansion: 'Villa',
        holidayHouse: 'Ferienhaus',
        countryHouse: 'Landhaus',
        twoFamilyHouse: 'Zweifamilienhaus',
        chalet: 'Chalet',
      },
    },
    price: {
      label: 'Preis',
    },
    roomCount: {
      label: 'Zimmer',
      to: 'bis',
    },
    livingSpace: {
      label: 'Wohnfläche',
    },
    propertySpace: {
      label: 'Grundstücksfläche',
    },
    usageSpace: {
      label: 'Nutzfläche',
    },
    sort: {
      label: 'Sortierung',
      newest: 'Neuste Objekte',
      lowestPrice: 'Niedrigster Preis',
      highestPrice: 'Höchster Preis',
    },
    rateOfReturn: {
      label: 'Bruttorendite',
    },
    units: {
      label: 'Einheiten',
    },
  },
  regionSearch: {
    city: 'Stadt',
    village: 'Ortschaft',
    county: 'Bezirk',
    suburb: 'Stadtteil',
    state: 'Kanton',
  },
  noResults: {
    title: 'Keine Resultate',
    text: `
      Speichern Sie Ihre Suche und werden Sie über die neusten Objekte benachrichtigt, die Ihren Kriterien
      entsprechen.
    `,
  },
  searchSubscription: {
    setup: 'Suchabo einrichten',
    save: 'Suchabo speichern',
    overlay: {
      title: 'Suchabo',
      text: `
        Gerne informieren wir Sie per E-Mail,
        sobald ein Objekt vorliegt, das Ihren Wünschen entspricht.
      `,
      showResults: 'Suchresultate anzeigen',
      changeFilter: {
        desktop: {
          part1: 'Ihre Kriterien können Sie in den',
          button: 'Filtern',
          part2: 'bearbeiten.',
        },
        mobile: {
          button: 'Suchkriterien bearbeiten',
        },
      },
    },
    stepper_title: {
      desktop: {
        step1: 'Suchkriterien setzen',
        step2: 'Suchkriterien setzen',
        step3: 'Suchabo abschliessen',
        step_final: 'Suchabo gespeichert',
      },
      mobile: {
        step1: 'Suchkriterien setzen',
        step2: 'Suchabo abschliessen',
        step_final: 'Suchabo gespeichert',
      },
    },
    search: {
      label: 'Kanton, Ort, PLZ, ...',
    },
    location: 'Ort',
    andRadius: 'und Umkreis',
    yourDetails: 'Ihre Angaben',
    yourSearchCriteria: 'Ihre Suchkriterien',
    toObjectSearch: 'Zur Objektsuche',
    cookieMessage: {
      description: `
        Um das Kontaktformular anzeigen zu können, akzeptieren Sie bitte die Cookies für Marketingzwecke.
      `,
      button: 'Cookies verwalten',
    },
    form: {
      firstName: 'Vorname',
      firstNameRequired: 'Vorname ist zwingend erforderlich.',
      lastName: 'Nachname',
      lastNameRequired: 'Nachname ist zwingend erforderlich.',
      email: 'E-Mail',
      emailRequired: 'E-Mail ist zwingend erforderlich.',
      receiveNewsletter: 'ImmoSky Newsletter abonnieren',
      newsletterHint: `Sie können sich jederzeit abmelden.`,
      acceptPrivacyHint: `Hiermit akzeptieren Sie die <a target="_blank" href="/de/agb/">AGB</a> & <a target="_blank" href="/de/datenschutz/">Datenschutzerklärung</a> von ImmoSky.`,
      thirdPartyHint: `
        Ihre Daten werden nicht an Dritte weitergegeben.
        Unsere <a target="_blank" href="/de/datenschutz/">Datenschutzerklärung finden Sie hier</a>.<br>
        Diese Site wird geschützt durch
        <a target="_blank" href="https://www.google.com/recaptcha/about/">reCAPTCHA</a> und es gelten die
        <a target="_blank" href="https://policies.google.com/privacy">Google Privacy</a>
        Richtlinien und Nutzungsbedingungen.
      `,
    },
    successMessage: {
      title: 'Suchabo eingerichtet',
      paragraph1: `
        Sie erhalten in Kürze einen Bestätigungslink per E-Mail.
      `,
      paragraph2: `
        Sobald Sie diesen bestätigt haben, erhalten Sie regelmässig E-Mails mit Objekten, die Ihren Wünschen entsprechen.
      `,
    },
  },
  similarObjects: {
    title: 'Ähnliche Objekte in der Nähe',
    xResults: '{count} Ergebnisse',
    modifySearch: {
      text: `
        Passen Sie die Suche an,<br>
        um mehr Resultate anzuzeigen.
      `,
      button: 'Suche anpassen',
    },
  },
  realEstateObject: {
    sold: 'Verkauft',
    priceOnRequest: 'Preis auf Anfrage',
    reserved: 'Reserviert',
    topOffer: 'Top-Objekt',
    virtualTour: '3D-Rundgang',
  },
  agentOverview: {
    agents: 'Immobilienmakler',
    director: 'Direktion',
    location: 'Standort',
    agentImagePlaceholderAlt: 'Platzhalter für das Maklerbild',
    region: "Region",
    properties: "Objekte",
    regions: {
      ch: {
        zh: 'Zürich',
        fr: 'Freiburg',
        vd: 'Waadt',
        ge: 'Genf',
        ne: 'Neuenburg',
        ju: 'Jura',
        be: 'Bern',
        vs: 'Wallis',
        ti: 'Tessin',
        ur: 'Uri',
        ow: 'Obwalden',
        nw: 'Nidwalden',
        lu: 'Luzern',
        bl: 'Basel Landschaft',
        bs: 'Basel Stadt',
        so: 'Solothurn',
        ag: 'Aargau',
        zg: 'Zug',
        gl: 'Glarus',
        gr: 'Graubünden',
        sz: 'Schwyz',
        sh: 'Schaffhausen',
        tg: 'Thurgau',
        sg: 'St. Gallen',
        ar: 'Appenzell Ausserrhoden',
        ai: 'Appenzell Innerrhoden',
      },
    }
  },
};
